import { render, staticRenderFns } from "./CommunityList.vue?vue&type=template&id=767377b0&scoped=true&lang=pug&"
import script from "./CommunityList.vue?vue&type=script&lang=js&"
export * from "./CommunityList.vue?vue&type=script&lang=js&"
import style0 from "./CommunityList.vue?vue&type=style&index=0&id=767377b0&prod&lang=sass&"
import style1 from "./CommunityList.vue?vue&type=style&index=1&id=767377b0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767377b0",
  null
  
)

export default component.exports